import React, { PureComponent } from "react";
import classnames from "classnames";

import { IEvent } from "@formant/core/model/IEvent";

import { commandStore } from "../../stores";
import { Chip } from "./Chip";
import * as styles from "./EventChip.scss";
import { SeverityChip } from "./SeverityChip";

export interface IEventChipProps {
    event: IEvent;
}

export class EventChip extends PureComponent<IEventChipProps> {
    public render() {
        const { event } = this.props;

        if (
            event.type === "triggered-event" ||
            event.type === "datapoint-event" ||
            event.type === "device-online" ||
            event.type === "device-offline"
        ) {
            return (
                <SeverityChip
                    severity={event.severity}
                    className={styles["event-chip"]}
                />
            );
        } else if (event.type === "stateful") {
            return (
                <SeverityChip
                    severity={event.severity ? event.severity : "info"}
                    className={styles["event-chip"]}
                />
            );
        } else if (event.type === "intervention-request") {
            return (
                <Chip
                    className={classnames(
                        styles["event-chip"],
                        styles.intervention,
                    )}
                />
            );
        } else if (event.type === "command-request") {
            return (
                <Chip
                    className={classnames(
                        styles["event-chip"],
                        styles["command-request"],
                    )}
                />
            );
        } else if (event.type === "command-delivery") {
            return (
                <Chip
                    className={classnames(
                        styles["event-chip"],
                        styles["command-delivery"],
                    )}
                />
            );
        } else if (event.type === "command-response") {
            const command = commandStore.get(event.commandId);
            if (command && command.success) {
                return (
                    <Chip
                        className={classnames(
                            styles["event-chip"],
                            styles["command-response"],
                        )}
                    />
                );
            } else {
                return (
                    <SeverityChip
                        severity="error"
                        className={styles["event-chip"]}
                    />
                );
            }
        } else if (event.type === "comment") {
            return (
                <Chip
                    className={classnames(styles["event-chip"], styles.comment)}
                />
            );
        } else if (event.type === "annotation") {
            return (
                <Chip
                    className={classnames(
                        styles["event-chip"],
                        styles.annotation,
                    )}
                />
            );
        } else if (event.type === "task-summary") {
            return (
                <Chip
                    className={classnames(
                        styles["event-chip"],
                        styles["task-summary"],
                    )}
                />
            );
        } else if (event.type === "custom") {
            if (event.severity) {
                return (
                    <SeverityChip
                        severity={event.severity}
                        className={styles["event-chip"]}
                    />
                );
            } else {
                return (
                    <Chip
                        className={classnames(
                            styles["event-chip"],
                            styles.custom,
                        )}
                    />
                );
            }
        } else if (event.type === "teleop-session-record") {
            return (
                <Chip
                    className={classnames(styles["event-chip"], styles.teleop)}
                />
            );
        } else if (event.type === "system") {
            return (
                <Chip
                    className={classnames(styles["event-chip"], styles.system)}
                />
            );
        }
        return false;
    }
}
